module.exports = __webpack_public_path__ + "static/media/delete_disable.f6035f07.svg";